import { render } from "./CreateOrders.vue?vue&type=template&id=dfb62104&scoped=true"
import script from "./CreateOrders.vue?vue&type=script&lang=js"
export * from "./CreateOrders.vue?vue&type=script&lang=js"

import "./CreateOrders.vue?vue&type=style&index=0&id=dfb62104&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb62104"]])

export default __exports__